// extracted by mini-css-extract-plugin
export default {"copyIcon":"create-reseller-prebuild-cart-popup__copyIcon___ogRDd"};